import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import MediaQuery from 'react-responsive';
import Spin from 'antd/lib/spin';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Slider from 'antd/lib/slider';
import Radio from 'antd/lib/radio';
import Tooltip from 'antd/lib/tooltip';
import rules from '../../../common/rules/rules';
import { paymentDestinationT } from '../../../common/enums';
import {
  currencyFormatter,
  percentageFormatter,
  monthsFormatter,
} from '../../../common/utils/helpers';
import allocationRules from '../../../common/rules/allocationRules';
import { CalculatorSlider } from '../../../common/components';
import config from '../../../config';
import CancelAutoInvest from './CancelAutoInvest';

const { Button: RadioButton, Group: RadioGroup } = Radio;
const { Item: FormItem } = Form;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

const getInterestSliderMarks = ({ min, max }) => ({
  [min]: <span>{percentageFormatter(min)}</span>,
  [max]: <span>{percentageFormatter(max)}</span>,
});

const getInvestmentMaxSliderMarks = (amount, step) => {
  let marks = {};
  if (amount) {
    marks = {
      [step]: <span>{currencyFormatter(step)}</span>,
      [amount]: <span>{currencyFormatter(amount)}</span>,
    };
  }
  return marks;
};

const getInvestmentMaxSliderStep = amount => {
  const range = config.automaticAllocationStepRanges.find(range => {
    if (range.min && range.max) {
      return amount > range.min && amount <= range.max;
    } else if (range.min) {
      return amount > range.min;
    } else if (range.max) {
      return amount <= range.max;
    }
    return false;
  });

  return range.step;
};

const parseNumber = val => parseInt(val, 10);

function getInterest(interestRange, months) {
  return parseFloat(
    interestRange.find(
      interest => months > interest.termMonthsMin && months <= interest.termMonthsMax
    ).allocationInterestMax
  );
}

@translate()
@Form.create()
export default class CreateAutomaticAllocation extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isCreating: PropTypes.bool.isRequired,
    accountBalance: PropTypes.number.isRequired,
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    calculatorMonthsMin: PropTypes.number.isRequired,
    calculatorMonthsMax: PropTypes.number.isRequired,
    calculatorMonthsStep: PropTypes.number.isRequired,
    defaultMonths: PropTypes.number.isRequired,
    interestRange: PropTypes.array.isRequired,
    autoinvest: PropTypes.object,
  };

  state = {
    show: false
  }

  showModal = e => {
    this.setState({
      show: !this.state.show
    });
  };

  onSubmit = () => {
    const { form, onSubmit } = this.props;

    form.validateFields({ force: true }, (err, values) => {
      if (!err) {
        onSubmit(values, true);
      }
    });
  };

  onCancel = () => {
    this.showModal()
  }

  render() {
    const {
      form,
      accountBalance,
      t,
      isCreating,
      defaultMonths,
      calculatorMonthsMin,
      calculatorMonthsMax,
      calculatorMonthsStep,
      interestRange,
      autoinvest,
      accountId
    } = this.props;

    const { getFieldDecorator, getFieldValue } = form;

    const currentMaxInterest = getInterest(
      interestRange,
      getFieldValue('termMonths') || defaultMonths
    );

    let interestsArray = interestRange.map(x => Number(x.allocationInterestMax))
    const interestMin = Math.min(...interestsArray)
    const interestMax = Math.max(...interestsArray)

    const interestSliderMarks = getInterestSliderMarks({
      min: interestMin,
      max: interestMax,
    });

    const amount = Math.max(parseNumber(getFieldValue('amount')) || 0, 0);
    const investmentMaxStep = getInvestmentMaxSliderStep(amount);

    return (
      <section className="automatic-allocation-wrapper">
        <h2>{t('Automatické investovanie')}</h2>

        <Spin spinning={isCreating}>
          <MediaQuery minWidth="1024px">
            <Row className="header">
              <Col xs={12} sm={6}>
                {t('Minimálny úrok')}
              </Col>
              <Col xs={12} sm={6}>
                {t('Maximálna dĺžka investície')}
              </Col>       
            </Row>
          </MediaQuery>

          <Form>
            <Row className="allocation-form">
              <Col xs={12} md={6} className="interest">
                <FormItem>
                  <MediaQuery maxWidth="1023px">
                    <p>{t('Minimálny úrok:')} </p>
                  </MediaQuery>
                  {getFieldDecorator('interest', {
                    rules: rules.required,
                    initialValue: (autoinvest && autoinvest.status === 'ON') ? Number(autoinvest.interest) : interestMin,
                  })(
                    <Slider
                      min={interestMin}
                      max={interestMax}
                      step={0.001}
                      marks={interestSliderMarks}
                      disabled={autoinvest && autoinvest.status === 'ON'}
                      // value={}
                      tipFormatter={percentageFormatter}
                    />
                  )}
                </FormItem>
              </Col>
              <Col xs={12} md={6} className="term-months">
                <FormItem>
                  <MediaQuery maxWidth="1023px">
                    <p>{t('Maximálna dĺžka investície:')} </p>
                  </MediaQuery>
                  {getFieldDecorator('termMonths', {
                    rules: rules.required,
                    initialValue: (autoinvest && autoinvest.status === 'ON') ? Number(autoinvest.termMonths) : defaultMonths,
                  })(
                    <CalculatorSlider
                      formatter={val => monthsFormatter(val, true)}
                      onChange={() => { }}
                      min={calculatorMonthsMin}
                      max={calculatorMonthsMax}
                      step={calculatorMonthsStep}
                      disabled={autoinvest && autoinvest.status === 'ON'}
                    />
                  )}
                </FormItem>
              </Col>
             
            </Row>
            <Row>
            </Row>
          </Form>

          <Row className="submit">
            <Col xs={12}>
              <Button onClick={(autoinvest && autoinvest.status === 'ON' )? this.onCancel : this.onSubmit} type='primary' >
                { (autoinvest && autoinvest.status === 'ON' )? t('Vypnúť autoinvest') : t('Zapnúť autoinvest') }
              </Button>
            </Col>
          </Row>
          <CancelAutoInvest values={form.values} onClose={this.showModal} show={this.state.show} accountId={accountId} />
        </Spin>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/components/CreateAutomaticAllocation.js